<div class="layerlist">
    <rask-layer-list
        (visibilityEvent)="onVisibilityChanged($event)"
        [id]="$safeNavigationMigration(mapsettings?.id)"
        [mapsettings]="mapsettings"
        [view]="view">
    </rask-layer-list>
</div>